/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'minimize': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M65.239 456.152H958.76v111.696H65.24V456.152z"/>'
  }
})
